import React from 'react';
import { motion } from 'framer-motion';
import { FiMapPin, FiPhone, FiMail, FiClock } from 'react-icons/fi';

export default function Contact() {
  return (
    <div className="bg-white py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="text-center"
        >
          <h2 className="text-3xl font-extrabold text-gray-900 sm:text-4xl">
            Kontakt Os
          </h2>
          <p className="mt-4 text-xl text-gray-500">
            Vi er altid klar til at hjælpe
          </p>
        </motion.div>

        <div className="mt-16">
          <div className="grid grid-cols-1 gap-8 md:grid-cols-2">
            <motion.div
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: 0.2, duration: 0.5 }}
              className="bg-amber-50 rounded-lg p-8"
            >
              <h3 className="text-2xl font-bold text-gray-900 mb-6">
                Kontaktinformation
              </h3>
              <div className="space-y-4">
                <div className="flex items-center">
                  <FiMapPin className="h-6 w-6 text-red-700 mr-4" />
                  <span>Hovedgaden 123, 2800 Kgs. Lyngby</span>
                </div>
                <div className="flex items-center">
                  <FiPhone className="h-6 w-6 text-red-700 mr-4" />
                  <span>+45 12 34 56 78</span>
                </div>
                <div className="flex items-center">
                  <FiMail className="h-6 w-6 text-red-700 mr-4" />
                  <span>info@bennyspolsevogn.dk</span>
                </div>
                <div className="flex items-start">
                  <FiClock className="h-6 w-6 text-red-700 mr-4" />
                  <div>
                    <p>Mandag - Fredag: 11:00 - 20:00</p>
                    <p>Lørdag: 12:00 - 20:00</p>
                    <p>Søndag: Lukket</p>
                  </div>
                </div>
              </div>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, x: 20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: 0.4, duration: 0.5 }}
              className="bg-amber-50 rounded-lg p-8"
            >
              <h3 className="text-2xl font-bold text-gray-900 mb-6">
                Send os en besked
              </h3>
              <form className="space-y-4">
                <div>
                  <label htmlFor="name" className="block text-sm font-medium text-gray-700">
                    Navn
                  </label>
                  <input
                    type="text"
                    id="name"
                    className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-red-500 focus:ring-red-500"
                  />
                </div>
                <div>
                  <label htmlFor="email" className="block text-sm font-medium text-gray-700">
                    Email
                  </label>
                  <input
                    type="email"
                    id="email"
                    className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-red-500 focus:ring-red-500"
                  />
                </div>
                <div>
                  <label htmlFor="message" className="block text-sm font-medium text-gray-700">
                    Besked
                  </label>
                  <textarea
                    id="message"
                    rows={4}
                    className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-red-500 focus:ring-red-500"
                  />
                </div>
                <button
                  type="submit"
                  className="w-full bg-red-700 text-white py-2 px-4 rounded-md hover:bg-red-800 transition-colors"
                >
                  Send Besked
                </button>
              </form>
            </motion.div>
          </div>
        </div>
      </div>
    </div>
  );
}